import LayoutContent from '../../components/layouts/content2';
import React, { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';
import { useRefresh } from '../../hooks/useRefresh';
import ListProducts from './ListProducts';
import CoctailScreen from './coctail.js';
import MargaritasScreen from './margaritas.js';
import WinesScreen from './wines.js';

function Index({ setShowHappy }) {
  const { i18n } = useTranslation();
  const langEng = i18n.language === 'en' ?? false;

  const { change } = useRefresh();

  const [menus, setMenus] = useState([]);

  const [showSpecials, setShowSpecials] = useState(false);
  const [showCoctatik, setshowCoctatik] = useState(false);
  const [showMargaritas, setshowMargaritas] = useState(false);
  const [showWines, setshowWines] = useState(false);
  const [showListProduct, setShowListProduct] = useState(false);
  const [dishs, setdishs] = useState(false);

  const [vodka, setvodka] = useState(false);
  const [chanpagne, setchanpagne] = useState(false);
  const [whiskey, setwhiskey] = useState(false);

  const [tequila, settequila] = useState(false);
  const [cognac, setcognac] = useState(false);
  const [beverages, setbeverages] = useState(false);
  const [mocktails, setmocktails] = useState(false);

  useEffect(() => {
    getData('menu').then((items) => {
      const data = items.value.data;

      setMenus(data);
    });
  }, [change]);

  useEffect(() => {
    menus.map((item) => {
      if (item.id === 415) {
        setchanpagne(item);
      }
      if (item.id === 405) {
        setwhiskey(item);
      }
      if (item.id === 403) {
        settequila(item);
      }
      if (item.id === 404) {
        setcognac(item);
      }
      if (item.id === 406) {
        setvodka(item);
      }
      if (item.id === 416) {
        setbeverages(item);
      }
      if (item.id === 418) {
        setmocktails(item);
      }
    });
  }, [menus]);

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 9999,
      }}
    >
      <LayoutContent
        showBack={true}
        setShowSpecials={setShowSpecials}
        setShowListProduct={setShowHappy}
      >
        <div style={{ padding: '0 20px' }}>
          <h1
            style={{
              color: 'white',
              textTransform: 'uppercase',
              fontSize: 40,
              fontWeight: '900',
              marginTop: 200,
            }}
          >
            bottle service / botellas
          </h1>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexWrap: 'wrap',
              paddingInline: 30,
              gap: 10,
            }}
          >
            <div
              onClick={() => {
                setdishs(chanpagne);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                width: 290,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  champagne
                </p>
              </div>
            </div>
            <div
              onClick={() => {
                setdishs(whiskey);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                width: 290,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  whiskey
                </p>
              </div>
            </div>

            <div
              onClick={() => {
                setdishs(vodka);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                marginTop: 20,
                width: 290,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  vodka
                </p>
              </div>
            </div>
            <div
              onClick={() => {
                setdishs(tequila);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                marginTop: 20,
                width: 290,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  tequila
                </p>
              </div>
            </div>

            <div
              onClick={() => {
                setdishs(cognac);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                marginTop: 20,
                width: 290,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  cognac
                </p>
              </div>
            </div>
            <div
              onClick={() => {
                setdishs(beverages);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                marginTop: 20,
                width: 290,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 41,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  beverages
                </p>
              </div>
            </div>
          </div>
        </div>

        {showListProduct && (
          <ListProducts dishs={dishs} setShowListProduct={setShowListProduct} />
        )}

        {showCoctatik && <CoctailScreen setShowHappy={setshowCoctatik} />}
        {showMargaritas && (
          <MargaritasScreen setShowHappy={setshowMargaritas} />
        )}
        {showWines && <WinesScreen setShowHappy={setshowWines} />}

        {showSpecials && (
          <SpecialsScreen
            setShowListProduct={setShowSpecials}
            setShowHappy={setShowHappy}
          />
        )}
      </LayoutContent>
    </div>
  );
}
export default Index;
